import './banner.css'
const Banner = () => {
    return (
        <div className='banner' />
    )
}
export default Banner